import {
  GET_SUPERVISED,
  SET_SUPERVISED_FILTERS,
  SAVE_TOKEN,
} from "redux/reducers/supervision/supervisedReducer";
import { api_post } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { api_get } from "./api";

const qid = process.env.REACT_APP_QID_INVOICES;
const migrationBrandId = process.env.REACT_APP_MIGRATION_BRAND_ID;

export const getSupervisedMigration = (startDate, endDate, station = {}, token) => {
  const paramsString = `?start=${startDate}&end=${endDate}&stations=${station?.id}`;
  const url = `${process.env.REACT_APP_URL_MIGRATIONS}/migrations${paramsString}`;
  const headers = { headers: { Authorization: token } };
  return async (dispatch) => {
    dispatch(startRequestComp('loadingSupervised'));
    await api_get(url, headers).then(resp => {
      if (Object.keys(resp).length === 0) {
        dispatch(setSnackbar('No se encontró inventario'));
        return;
      }
      dispatch({
        type: GET_SUPERVISED,
        payload: { liquidations: resp }
      });
    }).catch(error => {
      dispatch(setSnackbar(error || 'No se encontró inventario'));
    });
    dispatch(stopRequestComp('loadingSupervised'));
  };
};

export const setSupervisedFilters = (key = "", data) => {
  return {
    type: SET_SUPERVISED_FILTERS,
    payload: { data, key }
  };
};

export const apiToken = () => {
  const body = {
    name: "Migration",
    brand: migrationBrandId
  };
  const url = `${process.env.REACT_APP_URL_MIGRATIONS}/api?qid=${qid}`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingSupervised'));
    await api_post(url, body).then(resp => {
      dispatch({ type: SAVE_TOKEN, payload: resp });
      dispatch(stopRequestComp('loadingSupervised'));
    }).catch(error => {
      dispatch(setSnackbar(error?.message?.error || 'Error'));
      dispatch(stopRequestComp('loadingSupervised'));
    });
  };
};
